import React from "react";
import styled, { css } from "styled-components";

export interface PromotionalTagColorLabelProps {
  color: string;
}

const PromotionalTagColorLabel: React.ReactFCWithChildren<PromotionalTagColorLabelProps> = ({ color }) => {
  return (
    <ColoredBox color={color} />
  );
};

const ColoredBox = styled.div<{color: string}>`
  ${({ color }) => css`
    width: 10px;
    height: 10px;
    background: ${color};
    display: flex;
    align-items: center;
    margin-left: 1rem;
  `}
`;

export default PromotionalTagColorLabel;
